export const USER_COLORS = [
    'red',
    'pink', 
    'orange',
    'yellow',
    'indigo',
    'cyan',
    'blue',
    'teal',
    'green',
    'purple',
    'gray'
];

export const COLOR_HEX_MAP = {
    red: '#ef4444',
    pink: '#ec4899',
    orange: '#f97316',
    yellow: '#eab308',
    indigo: '#6366f1',
    cyan: '#06b6d4',
    blue: '#3b82f6',
    teal: '#14b8a6',
    green: '#22c55e',
    purple: '#a855f7',
    gray: '#6b7280'
};

export const COLOR_CLASSES = {
    blue: { border: 'border-blue-500', bg: 'bg-blue-100/90', text: 'text-blue-900' },
    green: { border: 'border-green-500', bg: 'bg-green-100/90', text: 'text-green-900' },
    pink: { border: 'border-pink-500', bg: 'bg-pink-100/90', text: 'text-pink-900' },
    yellow: { border: 'border-yellow-500', bg: 'bg-yellow-100/90', text: 'text-yellow-900' },
    red: { border: 'border-red-500', bg: 'bg-red-100/90', text: 'text-red-900' },
    purple: { border: 'border-purple-500', bg: 'bg-purple-100/90', text: 'text-purple-900' },
    indigo: { border: 'border-indigo-500', bg: 'bg-indigo-100/90', text: 'text-indigo-900' },
    teal: { border: 'border-teal-500', bg: 'bg-teal-100/90', text: 'text-teal-900' },
    orange: { border: 'border-orange-500', bg: 'bg-orange-100/90', text: 'text-orange-900' },
    cyan: { border: 'border-cyan-500', bg: 'bg-cyan-100/90', text: 'text-cyan-900' },
    gray: { border: 'border-gray-400', bg: 'bg-gray-100/90', text: 'text-gray-900' }
};
